export default __webpack_public_path__ + "static/international-yards-mobile-20ef40d5406d0cbf6d8fea9dbde0ab37.svg";